import { cloneDeep } from 'lodash'

import { Services, empty } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'

import { generateServices, globalErrorHandler, states } from '@/utils'

import render from './render'

const defaultPayload = {
  title: undefined,
  RoutingRules: []
}

export default {
  name: 'RoutesCreateFull',

  mixins: [
    generateServices([
      {
        name: Services.routingGroups,

        find: {
          defaultFilter: {
            title: undefined,
            isActive: true
          }
        },

        get: false,
        update: false,
        remove: false
      },
      {
        name: Services.routingRules,

        find: false,
        update: false,
        remove: false
      },
      {
        name: Services.providerGroups,

        find: false,
        update: false,
        remove: false
      },
      {
        name: Services.providers,

        find: false,
        create: false,
        update: false,
        remove: false
      }
    ])
  ],

  props: {
    show: Boolean,
    type: String
  },

  data() {
    return {
      colsToShow: 1,

      routingRuleIndex: undefined,

      payload: cloneDeep(defaultPayload),
      payloads: {
        routingRules: cloneDeep(empty.routingRules.create),
        providerGroups: cloneDeep(empty.providerGroups.create)
      }
    }
  },

  computed: {
    loading() {
      return this.restData.routingGroups.create.state === states.loading ||
      this.restData.routingRules.create.state === states.loading ||
      this.restData.providerGroups.create.state === states.loading
    },
    disabled() {
      return this.restData.routingGroups.find.pagination.total > 0 || this.loading
    },
    validation() {
      return {
        routingGroups: !!this.payload.title && this.payload.RoutingRules.length !== 0,
        routingRules: !!this.payloads.routingRules.title && this.payloads.routingRules.ProviderGroups.length !== 0,
        providerGroups: !!this.payloads.providerGroups.title && this.payloads.providerGroups.Providers.length !== 0 && this.payloads.providerGroups.Providers.every(({ id }) => {
          return id !== undefined
        })
      }
    }
  },

  methods: {
    async create() {
      try {
        const RoutingRules = await Promise.all(this.payload.RoutingRules.map(async (routingRule, routingRuleIndex) => {
          const routingRulesResult = {
            id: routingRule.id,
            title: routingRule.title,
            priority: routingRuleIndex,
            $attach: true
          }

          if (Array.isArray(routingRule.ProviderGroups)) {
            routingRule.ProviderGroups = await Promise.all(routingRule.ProviderGroups.map(async providerGroup => {
              const providerGroupsResult = {
                id: providerGroup.id,
                title: providerGroup.title,
                percentage: providerGroup.percentage || 100,
                $attach: true
              }
              if (!providerGroupsResult.id && providerGroupsResult.title) {
                const { id } = await this.rest.providerGroups.create(providerGroup)
                providerGroupsResult.id = id
              }

              return providerGroupsResult
            }))
          }

          if (!routingRulesResult.id && routingRulesResult.title) {
            const { id } = await this.rest.routingRules.create(routingRule)
            routingRulesResult.id = id
          }

          return routingRulesResult
        }))

        const routingGroup = await this.rest.routingGroups.create({
          title: this.payload.title,
          type: this.type,
          RoutingRules
        })
        this.$emit('input', routingGroup.id)
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.payload = cloneDeep(defaultPayload)
        this.$emit('showDialog', false)
      }
    },

    async addRoutingRuleFromSelect(id) {
      if (isUUID(id)) {
        if (!~this.payload.RoutingRules.findIndex(item => {
          return item.id === id
        })) {
          if (~[ states.empty, states.ready ].indexOf(this.restData.routingRules.get.state)) {
            try {
              const routingRule = await this.rest.routingRules.get(id)
              this.payload.RoutingRules.push({
                id: routingRule.id,
                title: routingRule.title
              })
            } catch (error) {
              globalErrorHandler(error)
            }
          }
        }
      }
    },

    addRoutingRuleFromForm() {
      if (this.validation.routingRules) {
        if (this.routingRuleIndex !== undefined) {
          this.payload.RoutingRules.splice(this.routingRuleIndex, 1, this.payloads.routingRules)
        } else {
          this.payload.RoutingRules.push(this.payloads.routingRules)
        }
        this.payloads.routingRules = cloneDeep(empty.routingRules.create)
        this.routingRuleIndex = undefined
        this.colsToShow -= 1
      }
    },
    addProviderGroupToRuleFromForm() {
      if (this.validation.providerGroups) {
        this.payloads.routingRules.ProviderGroups.push(this.payloads.providerGroups)
        this.payloads.providerGroups = cloneDeep(empty.providerGroups.create)
        this.colsToShow -= 1
      }
    }
  },

  render
}
